import * as React from 'react'
import { DirectionType, DirectionTypesOptions, TourDirectionModel, TourManageModel } from '../../models/TourManageModel'
import { FormFieldWrapper, WysiwygFieldController, WysiwygFormField } from 'traveldesk-ui'

interface Props {
    tour?: TourManageModel
    directions: TourDirectionModel[]
    onChange: (directions: TourDirectionModel[]) => void
}
const TourFormDirections = (props: Props) => {
    const onChange = (type: DirectionType) => (e: string) => {
        const newDirections = e
            ? props.directions.some(x => x.type == type)
                ? props.directions.map(x => x.type == type
                    ? Object.assign(TourDirectionModel.Create(x), { description: e })
                    : x)
                : props.directions.concat([Object.assign(new TourDirectionModel(), { tourId: props.tour?.id ?? 0, type, description: e })])
            : props.directions.filter(x => x.type != type)
        props.onChange(newDirections)
    }
    return <>
        <FormFieldWrapper>
            <label>Directions: </label>
        </FormFieldWrapper>
        {DirectionTypesOptions.map(type => <FormFieldWrapper>
            {/* <label>{type.label}</label> */}
            <WysiwygFormField
                label={type.label}
                value={props.directions.find(x => x.type == type.value)?.description ?? ""}
                onChange={
                    onChange(type.value)
                }
            />
            {/* <input type="text" value={props.directions.find(x => x.type == type.value)?.description} onChange={onChange(type.value)} /> */}
            <br />
        </FormFieldWrapper>
        )}
    </>
}
export default TourFormDirections